import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ClinicMedicationsAddPage } from './clinic-medications-add';

@NgModule({
  declarations: [
    ClinicMedicationsAddPage,
  ],
  imports: [
    IonicPageModule.forChild(ClinicMedicationsAddPage),
  ],
})
export class ClinicMedicationsAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/clinic-medications-add/clinic-medications-add.module.ts